export const customStyles = `
.seo-check {
    position: fixed;
    top: 85vh;
    left: 100px;
    right: calc(100% - 212px);
    background: rgba(0,0,0,0.8);
    border-radius: 13px;
    z-index: 10000;
    display: flex;
    flex-flow: column;
    padding: 10px;
    line-height: 1.8;
    font-size: 14px;
    transition: all 0.25s ease-in-out;
    font-family: sans-serif;
}
.seo-check.seo-modal {
    left: calc(50vw - 300px);
    right: calc(50vw - 300px);
    top: 25vh;
    max-height: 50vh;
    padding: 12px 20px 16px;
    overflow:hidden;
}
.seo-check-circle {
    border-radius: 50%;
    border: 2px solid rgba(255,255,255,0.8);
    flex: 0 0 26px;
    height: 26px;
    box-sizing: border-box;
    margin: -11px;
    cursor: pointer;
    transition: all 0.25s ease-in-out;
    z-index: 2;
    font-weight: 600;
    color: white;
    text-align: center;
    line-height: 24px;
}
.seo-check-circle:hover {
    transform:scale(1.2);
}
.seo-modal .seo-check-circle {
    margin: 0;
}
.seo-check-extralabel {
    position:absolute;
    left:0;
    right:0;
}
.seo-title {
    cursor: pointer;
    transition: all 0.25s ease-in-out;
    font-size:14px;
    white-space: nowrap;
    overflow: hidden;
    margin: -12px;
    margin-left: 12px;
    line-height: 2;
}
.seo-modal .seo-title {
    pointer-events: none;
    position:relative;
    font-size:20px;
    width:150px;
    opacity:1;
    margin:0;
    margin-left:4px;
}
.seo-header {
    display: flex;
    align-items: center;
    gap: 4px;
    color: white;
    font-weight: 400;
    margin-bottom: 0;
    transition: margin 0.25s ease-in-out;
}
.seo-modal .seo-header {
    margin-bottom: 10px;
}
.seo-check-title {
    cursor: pointer;
    display:flex;
    justify-content: space-between;
}
.seo-check-element {
    font-weight: 600;
    padding: 0;
    margin-top: -8px;
    margin-bottom: -25.5px;
    opacity: 0;
    transition: all 0.25s ease-in-out;
    white-space: nowrap;
    overflow: hidden;
    pointer-events: none;
}
.seo-check.seo-modal .seo-check-element {
    margin-top:0;
    margin-bottom:8px;
    opacity:1;
    width: auto;
    margin-left: 14px;
    pointer-events: all;
}
.seo-check-value {
    opacity:0;
    white-space:nowrap;
    transition: all 0.25s ease;
    margin-top:-25px;
    pointer-events:none;
    display:flex;
    justify-content: space-between;
    gap: 10px;
}
.seo-modal .seo-check-expanded .seo-check-value {
    opacity:0.8;
    margin-top:0;
    margin-left:10px;
}
.seo-check-score {
    opacity: 0.8;
}
.seo-check-icon {
    transform: rotate(-90deg);
    position: absolute;
    left: 22px;
    transition: transform 0.25s ease-in-out;
    font-weight: 600;
    margin-top: -1px;
}
.seo-check-expanded .seo-check-icon{
    transform: rotate(90deg);
}
.seo-header svg {
    width: 0;
    opacity: 0;
    transition: all 0.25s ease-in-out;
    margin-right: -5px;
    font-size: 20px;
    overflow: hidden;
    margin: -10px;
    margin-left:auto;
}
.seo-modal .seo-header svg {
    width:100px;
    opacity: 1;
    margin:0;
    margin-left:auto;
}
`
